import React from 'react';

import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import { Button, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { telefoneParaConversar } from "../../helpers/vcard";
import useConversarContato from "./useConversarContato";

const useStyles = makeStyles(() => ({
    card: {
        minWidth: 250,
        maxWidth: 320,
    },
    cabecalho: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "6px 4px 10px",
    },
    avatar: {
        width: 48,
        height: 48,
        flexShrink: 0,
    },
    info: {
        minWidth: 0,
    },
    nome: {
        fontWeight: 600,
        lineHeight: 1.25,
        wordBreak: "break-word",
    },
    linha: {
        display: "block",
        lineHeight: 1.35,
        wordBreak: "break-word",
    },
}));

// Um contato compartilhado (vCard). `contato` vem de helpers/vcard (lerVCards).
const VcardPreview = ({ contato, whatsappId }) => {
    const classes = useStyles();
    const { conversar, podeConversar } = useConversarContato(whatsappId);
    const telefone = telefoneParaConversar(contato);

    return (
        <div className={classes.card}>
            <div className={classes.cabecalho}>
                <Avatar src={contato.foto || undefined} className={classes.avatar} />
                <div className={classes.info}>
                    <Typography variant="subtitle1" color="primary" className={classes.nome}>
                        {contato.nome || "Contato sem nome"}
                    </Typography>
                    {contato.empresa && (
                        <Typography variant="caption" color="textSecondary" className={classes.linha}>
                            {contato.empresa}
                        </Typography>
                    )}
                    {contato.telefones.map((tel, indice) => (
                        <Typography key={`${tel.digitos}-${indice}`} variant="body2" className={classes.linha}>
                            {tel.numero}
                            {tel.rotulo && (
                                <Typography component="span" variant="caption" color="textSecondary">
                                    {` · ${tel.rotulo}`}
                                </Typography>
                            )}
                        </Typography>
                    ))}
                    {contato.emails.map((email) => (
                        <Typography key={email} variant="caption" color="textSecondary" className={classes.linha}>
                            {email}
                        </Typography>
                    ))}
                </div>
            </div>
            <Divider />
            <Button
                fullWidth
                color="primary"
                onClick={() => conversar(contato)}
                disabled={!podeConversar(contato)}
                title={telefone ? undefined : "Este contato não tem telefone"}
            >
                Conversar
            </Button>
        </div>
    );
};

export default VcardPreview;
